import { render, staticRenderFns } from "./StepCusInsured.vue?vue&type=template&id=1e85fbb6"
import script from "./StepCusInsured.vue?vue&type=script&lang=js"
export * from "./StepCusInsured.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports